export default __webpack_public_path__ + "static/media/productStrategy.bc5dd06d.svg";